import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".parallax-wrapper");

  blocks.forEach((block) => {
    const section = block.querySelector(".art-section");
    const plxTrack = section.querySelector(".parallax-track");
    const plxCamera = section.querySelector(".parallax-camera");
    const plxRows = section.querySelectorAll(".par-image-wrapper");

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: "top top",
        end: "bottom bottom",
        pin: plxCamera,
        // pinSpacing: false,
        markers: false,
      },
    });

    tl.fromTo(plxCamera, { opacity: 0 }, { opacity: 1 });

    // Efecto Parallax en imágenes
    plxRows.forEach((row) => {
      const image = row.querySelectorAll("img");
      image.forEach((img, i) => {
        tl.fromTo(
          img,
          { yPercent: 50 }, // Inicio: desplazadas 50px hacia abajo
          {
            yPercent: -50, // Final: desplazadas 50px hacia arriba
            scrollTrigger: {
              trigger: row,
              start: "top top", // Cuando la imagen entra en el viewport
              end: "bottom top", // Cuando la imagen sale del viewport
              scrub: true, // Efecto suave basado en el scroll
            },
          },
          `>`
        );
      });
    });
  });
});
